// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --Orange: #fe6100;
  --Green: #87bc45;
  --Red: #e00606;
  --WhiteSmoke: #f5f5f5;
  --White: #fff;
  --StockOrange: #ff7b29;
  --StockRed: #e00606;
  --SaddleBrown: #833505;
  --TotalBlack: #000000;
  --HightEmphasis: #212121;
  --LightBlack: #0f1d3e;
  --MediumEmphasis: #666;
  --LowEmphasis: #9e9e9e;
  --Gray88: #e0e0e0;
  --Gray85: #d9d9d9; }

.contacts_container__8mgWi {
  display: flex;
  flex-flow: column;
  height: 95%; }
  .contacts_container__8mgWi h2 {
    font-weight: 600;
    font-size: 32px;
    line-height: 150%;
    color: var(--HightEmphasis); }
  .contacts_container__8mgWi .contacts_breadcrumbs__ihVs2 {
    gap: 8px; }
    .contacts_container__8mgWi .contacts_breadcrumbs__ihVs2 span {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #666666; }
    .contacts_container__8mgWi .contacts_breadcrumbs__ihVs2 .contacts_breadcrumbs_active__qWgO\\+ {
      color: var(--LowEmphasis);
      cursor: pointer; }
  .contacts_container__8mgWi .contacts_title_box__7NBZP {
    display: flex;
    justify-content: space-between;
    position: relative;
    padding-bottom: 20px; }
    .contacts_container__8mgWi .contacts_title_box__7NBZP .contacts_title_go_back__jKXgy {
      display: flex;
      align-items: center; }
      .contacts_container__8mgWi .contacts_title_box__7NBZP .contacts_title_go_back__jKXgy h2 {
        padding-right: 10px; }
      .contacts_container__8mgWi .contacts_title_box__7NBZP .contacts_title_go_back__jKXgy .contacts_arrow_go_back__UvNmB {
        box-sizing: content-box;
        padding: 4px 10px;
        border-left: 1px solid #E0E0E0;
        cursor: pointer; }
    .contacts_container__8mgWi .contacts_title_box__7NBZP .contacts_control_box__6WxZT {
      display: flex;
      gap: 20px; }
      .contacts_container__8mgWi .contacts_title_box__7NBZP .contacts_control_box__6WxZT .contacts_settings_icon__Y0x58 g path {
        fill: #FE6100; }
  .contacts_container__8mgWi .contacts_form_container__Gh03x {
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    padding: 10px;
    background-color: var(--White);
    box-shadow: 0 0 8px rgba(68, 87, 104, 0.25);
    border-radius: 4px;
    height: 100%; }
    .contacts_container__8mgWi .contacts_form_container__Gh03x .contacts_name_section__J7ATv {
      display: flex;
      justify-content: space-between;
      flex-basis: 100%;
      padding-bottom: 30px;
      height: fit-content; }
      .contacts_container__8mgWi .contacts_form_container__Gh03x .contacts_name_section__J7ATv .contacts_name_input_wrap__Joe9H {
        width: 490px; }
    .contacts_container__8mgWi .contacts_form_container__Gh03x .contacts_second_Line__R1JBe {
      display: flex;
      width: 100%;
      gap: 80px; }
      .contacts_container__8mgWi .contacts_form_container__Gh03x .contacts_second_Line__R1JBe section {
        display: flex;
        flex-flow: column;
        gap: 30px;
        width: 100%; }
        .contacts_container__8mgWi .contacts_form_container__Gh03x .contacts_second_Line__R1JBe section .contacts_three_input_box__\\+6z58 {
          display: flex;
          gap: 35px; }

.contacts_title_contacts_box__oPW5a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px; }
  .contacts_title_contacts_box__oPW5a h2 {
    padding: 0;
    font-weight: 600;
    font-size: 24px;
    line-height: 150%;
    color: var(--HightEmphasis); }

.contacts_contacts_box__c7XN8 {
  display: flex;
  flex-flow: row wrap;
  row-gap: 20px;
  column-gap: 40px; }

.contacts_input_style__Z94qK {
  width: 100%;
  height: 40px;
  border: 1px solid var(--LowEmphasis);
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--HightEmphasis);
  padding: 13px 16px; }
  .contacts_input_style__Z94qK:focus {
    border-color: var(--HightEmphasis);
    outline: none; }

.contacts_select_style__2gX9e {
  width: 100%;
  height: 40px;
  border: 1px solid var(--LowEmphasis);
  border-radius: 4px;
  padding: 0 16px !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--HightEmphasis); }
  .contacts_select_style__2gX9e:focus {
    border-color: var(--HightEmphasis);
    outline: none; }

.contacts_settingsContainer__CFE19 {
  display: flex;
  justify-content: center;
  position: absolute;
  right: 50px;
  background-color: transparent;
  width: 150px;
  height: 150px;
  padding-top: 40px; }
  .contacts_settingsContainer__CFE19 svg {
    cursor: pointer; }
  .contacts_settingsContainer__CFE19 .contacts_settingsMenu__vr0R0 {
    position: absolute;
    background: #ffffff;
    box-shadow: 0 8px 10px rgba(0, 0, 0, 0.14);
    border-radius: 4px;
    z-index: 1001; }
    .contacts_settingsContainer__CFE19 .contacts_settingsMenu_item__Uk\\+2o {
      display: flex;
      align-items: center;
      width: 118px;
      padding: 6px 10px;
      cursor: pointer; }
      .contacts_settingsContainer__CFE19 .contacts_settingsMenu_item__Uk\\+2o .contacts_settingsText__dZw-3 {
        color: var(--LightBlack);
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        margin-left: 10px; }

.contacts_combobox_style__bfTxi {
  border: 0 !important; }
  .contacts_combobox_style__bfTxi > div:nth-child(1) {
    height: 40px;
    border: 1px solid var(--LowEmphasis);
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--HightEmphasis);
    box-shadow: none; }

.contacts_combobox_style_error__7GKrF > div:nth-child(1) {
  color: var(--Red) !important;
  border: 1px solid var(--Red) !important; }
  .contacts_combobox_style_error__7GKrF > div:nth-child(1) ::placeholder {
    color: var(--Red) !important; }

.contacts_combobox_container__TlR3H {
  position: relative; }
  .contacts_combobox_container__TlR3H .contacts_combobox_error_message__-08pn {
    position: absolute;
    bottom: -24px;
    left: 0;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: var(--Red); }
`, "",{"version":3,"sources":["webpack://./src/styles/colors.scss","webpack://./src/pages/company/contactsTab/contacts.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAAA;EAEE,iBAAS;EACT,gBAAQ;EACR,cAAM;EACN,qBAAa;EACb,aAAQ;EACR,sBAAc;EACd,mBAAW;EACX,sBAAc;EAGd,qBAAa;EACb,wBAAgB;EAChB,qBAAa;EACb,sBAAiB;EACjB,sBAAc;EAGd,iBAAS;EACT,iBAAS,EAAA;;ACjBX;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW,EAAA;EAHb;ICFE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDMf,2BAA2B,EAAA;EAN/B;IAUI,QAAQ,EAAA;IAVZ;MCwCE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MD7Bb,cAAc,EAAA;IAbpB;MAiBM,yBAAyB;MACzB,eAAe,EAAA;EAlBrB;IAuBI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,oBAAoB,EAAA;IA1BxB;MA6BM,aAAa;MACb,mBAAmB,EAAA;MA9BzB;QAiCQ,mBAAmB,EAAA;MAjC3B;QAqCQ,uBAAuB;QACvB,iBAAiB;QACjB,8BAA8B;QAC9B,eAAe,EAAA;IAxCvB;MA6CM,aAAa;MACb,SAAS,EAAA;MA9Cf;QAiDQ,aAAa,EAAA;EAjDrB;IAuDI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY,EAAA;IA9DhB;MAiEM,aAAa;MACb,8BAA8B;MAC9B,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB,EAAA;MArEzB;QAwEQ,YAAY,EAAA;IAxEpB;MA6EM,aAAa;MACb,WAAW;MACX,SAAS,EAAA;MA/Ef;QAkFQ,aAAa;QACb,iBAAiB;QACjB,SAAS;QACT,WAAW,EAAA;QArFnB;UAwFU,aAAa;UACb,SAAS,EAAA;;AAOnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB,EAAA;EAJrB;IAMI,UAAU;IClGZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDkGf,2BAA2B,EAAA;;AAI/B;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;ECrFlB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDqFjB,2BAA2B;EAC3B,kBAAkB,EAAA;EAPpB;IASI,kCAAkC;IAClC,aAAa,EAAA;;AAIjB;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;ECpG1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDoGjB,2BAA2B,EAAA;EAP7B;IASI,kCAAkC;IAClC,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,iBAAiB,EAAA;EARnB;IAWI,eAAe,EAAA;EAXnB;IAcI,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa,EAAA;IAlBjB;MAoBM,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,iBAAiB;MACjB,eAAe,EAAA;MAxBrB;QA0BQ,wBAAwB;QCjI9B,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QDiIX,iBAAiB,EAAA;;AAMzB;EACE,oBAAoB,EAAA;EADtB;IAGI,YAAY;IACZ,oCAAoC;ICnJtC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDmJf,2BAA2B;IAG3B,gBAAgB,EAAA;;AAIpB;EAEI,4BAA4B;EAC5B,uCAAuC,EAAA;EAH3C;IAKM,4BAA4B,EAAA;;AAKlC;EACE,kBAAkB,EAAA;EADpB;IAII,kBAAkB;IAClB,aAAa;IACb,OAAO;IC9IT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;ID8If,iBAAiB,EAAA","sourcesContent":[":root {\n  // Product\n  --Orange: #fe6100;\n  --Green: #87bc45;\n  --Red: #e00606;\n  --WhiteSmoke: #f5f5f5;\n  --White: #fff;\n  --StockOrange: #ff7b29;\n  --StockRed: #e00606;\n  --SaddleBrown: #833505;\n\n  // On Surface\n  --TotalBlack: #000000;\n  --HightEmphasis: #212121;\n  --LightBlack: #0f1d3e;\n  --MediumEmphasis: #666;\n  --LowEmphasis: #9e9e9e;\n\n  // Border\n  --Gray88: #e0e0e0;\n  --Gray85: #d9d9d9;\n}\n","@import '../../../styles/colors';\n@import '../../../styles/fonts';\n\n.container {\n  display: flex;\n  flex-flow: column;\n  height: 95%;\n  h2 {\n    @include h1;\n    color: var(--HightEmphasis);\n  }\n\n  .breadcrumbs {\n    gap: 8px;\n    span {\n      @include body2;\n      color: #666666;\n    }\n\n    .breadcrumbs_active {\n      color: var(--LowEmphasis);\n      cursor: pointer;\n    }\n  }\n\n  .title_box {\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    padding-bottom: 20px;\n\n    .title_go_back {\n      display: flex;\n      align-items: center;\n\n      h2 {\n        padding-right: 10px;\n      }\n\n      .arrow_go_back {\n        box-sizing: content-box;\n        padding: 4px 10px;\n        border-left: 1px solid #E0E0E0;\n        cursor: pointer;\n      }\n    }\n\n    .control_box {\n      display: flex;\n      gap: 20px;\n\n      .settings_icon g path {\n        fill: #FE6100;\n      }\n    }\n  }\n\n  .form_container {\n    display: flex;\n    flex-flow: row wrap;\n    align-content: flex-start;\n    padding: 10px;\n    background-color: var(--White);\n    box-shadow: 0 0 8px rgba(68, 87, 104, 0.25);\n    border-radius: 4px;\n    height: 100%;\n\n    .name_section {\n      display: flex;\n      justify-content: space-between;\n      flex-basis: 100%;\n      padding-bottom: 30px;\n      height: fit-content;\n\n      .name_input_wrap {\n        width: 490px;\n      }\n    }\n\n    .second_Line {\n      display: flex;\n      width: 100%;\n      gap: 80px;\n\n      section {\n        display: flex;\n        flex-flow: column;\n        gap: 30px;\n        width: 100%;\n\n        .three_input_box {\n          display: flex;\n          gap: 35px;\n        }\n      }\n    }\n  }\n}\n\n.title_contacts_box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  h2 {\n    padding: 0;\n    @include h2;\n    color: var(--HightEmphasis);\n  }\n}\n\n.contacts_box {\n  display: flex;\n  flex-flow: row wrap;\n  row-gap: 20px;\n  column-gap: 40px;\n}\n\n.input_style {\n  width: 100%;\n  height: 40px;\n  border: 1px solid var(--LowEmphasis);\n  border-radius: 4px;\n  @include body1;\n  color: var(--HightEmphasis);\n  padding: 13px 16px;\n  &:focus {\n    border-color: var(--HightEmphasis);\n    outline: none;\n  }\n}\n\n.select_style {\n  width: 100%;\n  height: 40px;\n  border: 1px solid var(--LowEmphasis);\n  border-radius: 4px;\n  padding: 0 16px !important;\n  @include body1;\n  color: var(--HightEmphasis);\n  &:focus {\n    border-color: var(--HightEmphasis);\n    outline: none;\n  }\n}\n\n.settingsContainer {\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  right: 50px;\n  background-color: transparent;\n  width: 150px;\n  height: 150px;\n  padding-top: 40px;\n\n  svg {\n    cursor: pointer;\n  }\n  .settingsMenu {\n    position: absolute;\n    background: #ffffff;\n    box-shadow: 0 8px 10px rgba(0, 0, 0, 0.14);\n    border-radius: 4px;\n    z-index: 1001;\n    &_item {\n      display: flex;\n      align-items: center;\n      width: 118px;\n      padding: 6px 10px;\n      cursor: pointer;\n      .settingsText {\n        color: var(--LightBlack);\n        @include body2;\n        margin-left: 10px;\n      }\n    }\n  }\n}\n\n.combobox_style {\n  border: 0 !important;\n  & > div:nth-child(1) {\n    height: 40px;\n    border: 1px solid var(--LowEmphasis);\n    @include body1;\n    color: var(--HightEmphasis);\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n  }\n}\n\n.combobox_style_error {\n  & > div:nth-child(1) {\n    color: var(--Red) !important;\n    border: 1px solid var(--Red) !important;\n    ::placeholder {\n      color: var(--Red) !important;\n    }\n  }\n}\n\n.combobox_container {\n  position: relative;\n\n  .combobox_error_message {\n    position: absolute;\n    bottom: -24px;\n    left: 0;\n    @include caption;\n    color: var(--Red);\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `contacts_container__8mgWi`,
	"breadcrumbs": `contacts_breadcrumbs__ihVs2`,
	"breadcrumbs_active": `contacts_breadcrumbs_active__qWgO+`,
	"title_box": `contacts_title_box__7NBZP`,
	"title_go_back": `contacts_title_go_back__jKXgy`,
	"arrow_go_back": `contacts_arrow_go_back__UvNmB`,
	"control_box": `contacts_control_box__6WxZT`,
	"settings_icon": `contacts_settings_icon__Y0x58`,
	"form_container": `contacts_form_container__Gh03x`,
	"name_section": `contacts_name_section__J7ATv`,
	"name_input_wrap": `contacts_name_input_wrap__Joe9H`,
	"second_Line": `contacts_second_Line__R1JBe`,
	"three_input_box": `contacts_three_input_box__+6z58`,
	"title_contacts_box": `contacts_title_contacts_box__oPW5a`,
	"contacts_box": `contacts_contacts_box__c7XN8`,
	"input_style": `contacts_input_style__Z94qK`,
	"select_style": `contacts_select_style__2gX9e`,
	"settingsContainer": `contacts_settingsContainer__CFE19`,
	"settingsMenu": `contacts_settingsMenu__vr0R0`,
	"settingsMenu_item": `contacts_settingsMenu_item__Uk+2o`,
	"settingsText": `contacts_settingsText__dZw-3`,
	"combobox_style": `contacts_combobox_style__bfTxi`,
	"combobox_style_error": `contacts_combobox_style_error__7GKrF`,
	"combobox_container": `contacts_combobox_container__TlR3H`,
	"combobox_error_message": `contacts_combobox_error_message__-08pn`
};
export default ___CSS_LOADER_EXPORT___;
